import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { resolveHealthInsuranceANSoVeRefCount } from '../server/resolver/resolveHealthInsuranceANSoVeRefCount.js';

export enum HealthInsuranceTypes {
  A = 'A',
  E = 'E',
  B = 'B',
  I = 'I',
  L = 'L',
  U = 'U',
  V = 'V',
  P = 'P',
}
registerEnum({ enum: HealthInsuranceTypes, name: 'HealthInsuranceTypes' });

/**
 * @entity HealthInsurance
 */
@Entity()
export class HealthInsurance extends MongoEntity {
  public static override _class = 'HealthInsurance';
  public static override _collectionName = 'healthinsurances';

  constructor(doc: PartialEntityData<HealthInsurance>) {
    super(doc);
  }
  static override async beforeRemove(id: string, entityData: any) {
    await super.beforeRemove(id, entityData);
    const refCount = await resolveHealthInsuranceANSoVeRefCount(id)();

    if (refCount >= 1)
      throw new Error(
        `Die "${entityData.bezeichnung}" ist noch ${refCount}x in gebrauch! Bitte entfernen Sie alle Vorkommnisse und probieren es erneut... `,
      );
  }

  public override toString() {
    return this.bezeichnung + (this.ort ? ', ' + this.ort : '');
  }

  @validate(nonOptional())
  @Field(type => String)
  public rahmenNr!: string;

  @Field(type => String)
  public krankenkasse?: string;

  @validate(nonOptional())
  @Field(type => String)
  public bezeichnung!: string;

  @validate(nonOptional())
  @Field(type => String)
  public ort!: string;

  @validate(nonOptional())
  @Field(type => String)
  public krkArt!: HealthInsuranceTypes;

  @Field(type => Date)
  public gueltigBis: Maybe<Date>;

  @validate(nonOptional())
  @Field(type => Int)
  public betriebsnummer!: number;

  @validate(nonOptional())
  @Field(type => String)
  public iban!: string;
}
